{
  "startCopy": "Копировать",
  "endCopy": "Скопировано!"
}
